module.exports = __webpack_public_path__ + "img/billing-info-icon.9cf36c34.png";